export { fromEvent } from './file-selector';
//# sourceMappingURL=index.js.map